import React, { useState } from "react";
import ArrowUpward from "../../assets/svg/ArrowUpward";
import dayjs from "dayjs";
import ProSVG from "../../assets/svg/ProSVG";
import { ICelebrateComingSoon } from "../client/Category/ICelebrateComingSoon";

const start_date = dayjs(new Date()).add(1, "day").format("MMM DD, YYYY");

const datas = [
  {
    account_code: "2abcd123ef",
    booking_code: "2XY7A33190",
    client_name: "Juan dela Cruz",
    description: "",
    location: "Manila",
    pax: "200",
    start_date: start_date,
    time: "02:00PM",
    title: "Wedding at Manila Hotel",
    total_amount: "500.00",
  },
  {
    account_code: "3qwerty45z",
    booking_code: "3PL4M66125",
    client_name: "Josefa Mercado",
    description: "",
    location: "Pasig",
    pax: "50",
    start_date: start_date,
    time: "06:00PM",
    title: "Birthday Celebration",
    total_amount: "300.00",
  },
  {
    account_code: "4xyz789abc",
    booking_code: "4KL2D54180",
    client_name: "Amado Hernandez",
    description: "",
    location: "Makati",
    pax: "300",
    start_date: start_date,
    time: "09:00AM",
    title: "Corporate Event",
    total_amount: "1000.00",
  },
];

const PotentialClients = () => {
  const [isComingSoon, setComingSoon] = useState(false);
  const renderComponent = (event, key) => {
    return (
      <div key={key} className="p-5 blur-sm flex flex-col bg-primary-50  rounded-lg ">
        <div className="pointer-events-none select-none">
          <div className="flex flex-row mt-2">
            <div className="mr-3 rounded-full bg-sunrise-500 w-10 h-10 flex items-center justify-center text-white font-semibold text-sm">
              {event.client_name.charAt(0)}
            </div>
            <div className="flex flex-col self-center">
              <p className="text-primary-600 font-semibold">{event.client_name}</p>
            </div>
          </div>
  
          <div className="flex flex-col text-primary-600 text-xs mt-3">
            <div className="flex gap-x-2 items-center flex-row">
              <div className="w-5 h-5">
                <div
                  className="icon-listing h-full w-full "
                  style={{ backgroundPositionY: "center" }}
                />
              </div>
              <p>{event.title}</p>
            </div>
            <div className="flex gap-x-2 items-center flex-row">
              <div className="w-5 h-5">
                <div
                  className="icon-calendar h-full w-full "
                  style={{ backgroundPositionY: "center" }}
                />
              </div>
              <p>{event.start_date}</p>
            </div>
            <div className="flex gap-x-2 items-center flex-row">
              <div className="w-5 h-5">
                <div
                  className="icon-location h-full w-full "
                  style={{ backgroundPositionY: "center" }}
                />
              </div>
              <p>{event.location}</p>
            </div>
          </div>
        </div>
  
        <div className="cursor-pointer rounded-full p-2 bg-primary-500 mt-5">
          <p className="text-white text-sm text-center">Message</p>
        </div>
      </div>
    );
  };
  
  return (
    <div className="flex flex-col space-y-4 pb-4">
      {/* Upgrade to PRO */}
      <div
        className="bg-white rounded-2xl shadow-md px-4 py-3 cursor-pointer flex items-center space-x-4"
        onClick={() => setComingSoon(true)}
      >
        <div className="flex flex-col flex-1 space-y-2">
          <div className="flex items-center space-x-2">
            <p className="text-lg font-medium text-gray-800">Upgrade to</p>
            <ProSVG />
          </div>
          <p className="text-xs text-gray-600">
            Upgrade to Anyaya Pro to connect directly with potential clients and
            craft irresistible offers for them.
          </p>
        </div>
        <ArrowUpward />
      </div>

      {/* Event Inquiries List */}
      <div className="w-full gap-5 mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-4">
        {datas.map((data, key) => {
          return renderComponent(data, key);
        })}
      </div>

      {/* Modal */}
      {isComingSoon && (
        <ICelebrateComingSoon handleClose={() => setComingSoon(false)} />
      )}
    </div>
  );
};

export default PotentialClients;
